export default {
  参展参会: 'Attendees and Exhibitors',
  执行指挥: 'Executive Commander',
  安保总指挥: 'Head of Security',
  媒体: 'Media',
  保安: 'Guard',
  总指挥: 'Head',
  服务保障: 'Service',
  执行副指挥: 'Executive Deputy Commander',
  现场指挥: 'On-site Commander',
  嘉宾: 'Guest',
  安保指挥: 'Security Commander',
  交易团: 'Trade Delegation',
  组委会: 'Organizing Committee',
  执委会: 'Executive Committee',
  副指挥: 'Deputy Commander',
  安保: 'Security',
  志愿者: 'Volunteer',
  参展商: 'Exhibitor',
  专业观众: 'Professional Visitor',
  搭建施工: 'Setup',
  贵宾: 'VIP',
  副总指挥: 'Deputy Head',
  证件已领取: 'Badge Obtained',
  证件是否激活: 'Do you want to activate your badge?',
  激活已受理: 'Activation Accepted',
  证件未激活: 'Badge Not Activated',
  北京健康宝状态: 'Beijing Health Kit Status',
  绿色: 'Green',
  健康宝状态异常: 'Health Kit Exception',
  核酸时间: 'Nucleic Acid Test Time',
  天: 'Day(s)',
  立刻更新防疫申报: 'Update information now',
  立即提交证件激活: 'Submit the Badge for Activation Now',
  查询是否可以进场: 'Query Whether You Can Enter the Site',
  服贸会入场防疫要求: 'Entry Requirements for COVID-19 Prevention:',
  '1.须扫描证件背后二维码，提交证件激活申请':
    '1. Please scan the QR code on the back of the badge and submit your badge activation application',
  '2.北京健康宝须为正常状态':
    '2. Ensure that your Beijing Health Kit displays normal health status',
  '3.如您申请的证件为执行指挥、安保总指挥、媒体、保安、总指挥、服务保障、执行副指挥、现场指挥、安保指挥、组委会、执委会、副指挥、安保、志愿者、参展商、交易团、副总指挥，进场当日核酸时间须为0、1；如您申请的证件为嘉宾、参展参会，进场当日核酸时间须为0、1、2。': `3. If you apply for the badge of executive commander, head of security, media, guard, service, executive deputy commander, on-site commander, security commander, organizing committee, executive committee, deputy commander, security, volunteer, exhibitor, trade delegation or deputy head, please ensure that your nucleic acid test result indicates "0" or "1" day on the Health Kit on the day of entry; if you apply for the badge of guest or attendees and exhibitors, please ensure that your nucleic acid test result indicates "0", "1" or "2" days on the Health Kit on the day of entry.`,
  '4.如您申请的证件为执行指挥、安保总指挥、媒体、保安、总指挥、服务保障、执行副指挥、现场指挥、安保指挥、组委会、执委会、副指挥、安保、志愿者、参展商、副总指挥、嘉宾、参展参会，须满足提前3天进京，并且抵京3天内完成两次核酸检测（采样时间至少间隔24小时），核酸检测结果均阴性方可参加服贸会工作；如您申请的证件为交易团证，须满足提前1天进京。': `4. If you apply for the badge of executive commander, head of security, media, guard, service, executive deputy commander, on-site commander, security commander, organizing committee, executive committee, deputy commander, security, volunteer, exhibitor, deputy head, guest or attendees and exhibitors, please arrive in Beijing 3 days ahead of schedule, and two nucleic acid tests (sampling time interval of at least 24 hours) must be completed within 3 days after arriving in Beijing, and the results of nucleic acid tests must be negative, if you apply for the badge of trade delegation, please arrive in Beijing 1 day ahead of schedule.`,
  查询是否可进场状态: 'Check whether admission application is accepted.',
  可进场: 'Admitte',
  入场状态待确认: 'Admission status to be confirmed',
  姓名: 'Name',
  身份证号: 'ID Card No.',
  最新状态: 'Latest Status',
  证件待领取: 'Badge to obtain',
  证件制作中: 'Badge in production',
  正常: 'Normal',
  异常: 'Abnormal',
  是否满足提前进京要求:
    'Whether the requirements for arriving in Beijing in advance are met',
  是: 'Yes',
  否: 'No',
  有: 'Yes',
  无: 'No',
  北京健康宝: 'Beijing Health Kit',
  未提交激活: 'Activation not submitted',
  立刻更新信息: 'Update information now',
  '核酸结果更新中，请稍后查看': '核酸结果更新中，请稍后查看',
  '是否可进场状态将于每日凌晨更新，请您及时关注查看，了解最新情况。':
    'Admission status will be updated every early morning. Please keep updated.',

  个人信息收集清单: 'Checklist of Personal Information to Be Collected',
  个人信息共享清单: 'Checklist of Shared Personal Information',
  注册协议: 'Registration Agreement',
  '隐私政策（简要版）': 'Privacy Policy (simplified)',
  应用权限申请与使用情况说明:
    'Application for App Permissions and Instructions for Use',
  下载服贸会APP: 'Download CIFTIS APP',
  下载服贸会视频会议APP: 'Download',
  请输入企业名称: 'Enter an enterprise name',
  '加载中...': 'loading...',
  暂无数据: 'No data available',
  无数据: 'No data available',
  暂无消息: 'No message available',
  '已经到底了~': 'The End~',
  活动详情: 'Event details',
  承办机构: 'Host',
  最新活动: 'Latest activities',
  请输入要查询的机构: 'Enter the organization to be searched',
  请输入要查询的活动: 'Enter the event to be searched',
  展会图册: 'Exhibition Atlas',
  已经是最后一张: 'The Last Page',
  公司简介: 'About Us',
  联系方式: 'Contact Information',
  电话: 'Phone',
  邮箱: 'Email',
  搜索内容不能为空: 'Search content cannot be empty',
  搜索内容不能全是特殊字符: 'Search content cannot be only special characters',
  服贸会: 'CIFTIS',
  用户服务协议与隐私政策: 'Service Agreement And Privacy Policy',
  展会服务: 'Exhibition Service',
  展会介绍: 'Exhibition Introduction',
  展商名录: 'Exhibitor List',
  展商名录详情: 'Details of Corporate Attendees',
  会议交流: 'Conference Dialogues',
  展区图册: 'Exhibition Album',
  企业成员: 'Corporate Contacts',
  '网络异常，请稍后重试': 'Network exception, please try again',
  '您访问的页面找不到了~': 'Page not found~',
  页面找不到: 'Page not found',
  '服务器未响应~': 'No response from the server~',
  服务器未响应: 'No response from the server',
  '无法连接网络，请检查网络或重试~':
    'Unable to connect the network, please diagnose network or retry~',
  无法连接网络: 'Unable to connect the network',
  '请求失败，请稍后重试~': 'Request failed, please try again later~',
  无权限温馨提示: 'Access denied',
  '本页面仅支持登录访问，请先登录！':
    'This page only supports login to access, please login first!',
  '登录提示：': 'Login Tips:',
  去登录: 'Login',
  温馨提示: 'Tips',
  '您为个人用户无访问权限，请先至服贸会官网-账户中心完善资质。':
    'You do not have the access right as an individual user. Please correct your qualifications in CIFTIS - Account Center.',
  点击重试: 'Click to Retry',
  点击复制下载链接: 'Click to copy the download url',
  免费注册: 'Regist Free',
  中国国际服务贸易交易会: 'China International Fair for Trade in Services',
  '移动随行，呈现永不落幕的服贸会':
    'A never-ending service trade fair you can take with you anywhere',
  '北京市国际服务贸易事务中心版权所有 京ICP备12034776':
    'Beijing International Service Trade Center Copyright J ICP B No.12034776',
  京公安备11010502026749: 'Beijing Public Security 11010502026749',
  登录: 'Login',
  共: 'Total ',
  条: ' results',
  条结果: 'results',
  条相关搜索结果: ' search results',
  立即沟通: 'Chat now',
  商务代表: 'Trade representative',
  咨询组: 'Advisory Group',
  客服代表: 'Customer service representative',
  '敬请期待…': 'Stay tuned...',
  取消: 'Cancel',
  下载: 'Download',
  '该企业尚未配置客服，不支持在线沟通~':
    'The company has not yet configured customer service and does not support online communication ~',
  首页: 'Home Page',
  搜索: 'Search',
  行业分类: 'Industry classification',
  第: 'The ',
  页: ' Page',
  搜索结果: 'Search Results',
  未找到企业数据: 'Enterprise data not found',
  暂无企业数据: 'No enterprise data',
  暂无描述: 'No description',
  在线洽谈: 'Chat',
  '系统繁忙，请稍后重试~': 'The system is busy, please try again later ~',
  暂无结果: 'No results',
  '对不起，你无此操作权限': 'Sorry, you do not have this operation permission',
  无此操作权限: 'Do not have this operation permission',
  根据您的手机选择下载服贸会移动客户端:
    'According to your mobile phone choose to download the CIFTIS APP',
  根据您的设备选择下载服贸会视频会议客户端:
    'According to your device choose to download the APP',
  企业信息: 'Entity Information',
  注册地: 'Address',
  单位性质: 'Entity Nature',
  所属行业: 'Industry',
  国内企业: 'Domestic enterprises',
  国际企业: 'International enterprises',
  其他机构: 'Other organizations',
  '其他机构（各个商业组织机构、商业协会、行业协会、院校、医院等社会组织）':
    'Other organizations (Other organizations include: various business organizations, business associations, industry associations, colleges, hospitals and other social organizations)',
  '其他机构包括：各个商业组织机构、商业协会、行业协会、院校、医院等社会组织':
    'Other organizations include: various business organizations, business associations, industry associations, colleges, hospitals and other social organizations',
  进入展台: 'Visit Booth',
  '系统提示：': 'Tips:',
  '系统繁忙，请稍后再试': 'The system is busy. Please try again later',
  '目前操作人数过多，系统繁忙，请稍后刷新再试一次。':
    'There are too many operators at present and the system is busy. Please refresh the page and try again later.',
  消息中心: 'Message Center',
  今天: 'Today',
  已读: 'Read',
  删除: 'Delete',
  全选: 'Select All',
  隐私策略: 'Privacy Policy',
  云会议客户端桌面版: 'CIFTIS Cloud Meeting Client',
  立即下载: 'Download',
  确定: 'OK',
  境内: 'Domestic',
  港澳台: 'HK/TW/Macau',
  境外: 'Overseas',
  台湾地区: 'Taiwan',
  澳门地区: 'Macao',
  香港地区: 'Hong Kong',
  北京市: 'Beijing',
  天津市: 'Tianjin',
  重庆市: 'Chongqing',
  上海市: 'Shanghai',
  河北省: 'Hebei',
  山西省: 'Shanxi',
  辽宁省: 'Liaoning',
  吉林省: 'Jilin',
  黑龙江省: 'Heilongjiang',
  江苏省: 'Jiangsu',
  浙江省: 'Zhejiang',
  安徽省: 'Anhui',
  福建省: 'Fujian',
  江西省: 'Jiangxi',
  山东省: 'Shandong',
  河南省: 'Henan',
  湖北省: 'Hubei',
  湖南省: 'Hunan',
  广东省: 'Guangdong',
  海南省: 'Hainan',
  四川省: 'Sichuan',
  贵州省: 'Guizhou',
  云南省: 'Yunnan',
  陕西省: 'Shanxi',
  甘肃省: 'Gansu',
  青海省: 'Qinghai',
  内蒙古: 'Inner Mongoria IM',
  广西壮族: 'Guangxi',
  西藏: 'Tibet',
  宁夏回族: 'Ningxia',
  新疆: 'Xinjiang',
  阿富汗: 'Afghanistan',
  格陵兰: 'Greenland',
  瓜德罗普: 'Guadeloupe',
  吉尔吉斯共和国: 'Kyrgyz republic',
  新喀里多尼亚岛: 'New Caledonia',
  北马里亚纳群岛: 'Northern Mariana Islands',
  巴拉圭: 'Paraguay',
  波多黎哥: 'Puerto Rico',
  俄罗斯: 'Russia',
  圣赫勒拿岛: 'Saint Helena',
  圣基茨和尼维斯联邦: 'The Federation of Saint Kitts and Nevis',
  萨摩亚群岛: 'Samoa islands',
  圣多美岛和普林西比岛: 'SAO tome and principe',
  斯瓦尔巴特群岛: 'Svalbard',
  托克劳群岛: 'Tokelau islands',
  阿联酋: 'United Arab Emirates',
  '维京岛(英)': 'Virgin island (UK)',
  '维京岛(美)': 'Virgin island (USA)',
  瓦利斯和富图纳群岛: 'Wallis and futuna islands',
  南苏丹: 'South Sudan',
  波黑: 'Bosnia and Herzegovina',
  美属萨摩亚群岛: 'American Samoa',
  佛得角群岛: 'Cape verde islands ',
  开曼群岛: 'Cayman Islands',
  中非共和国: 'Central African Republic',
  科摩罗群岛: 'The comoros islands',
  '刚果共和国/刚果(布)': 'Republic of Congo/Congo (Brazzaville)',
  '刚果民主共和国/刚果(金)':
    'Democratic republic of the Congo/democratic republic of the Congo (DRC)',
  捷克共和国: 'Czech Republic',
  多米尼克: 'Dominica',
  多米尼加共和国: 'Dominican Republic',
  马尔维那斯群岛: 'Malvinas Islands',
  法属玻利尼西亚: 'French Polynesia',
  奥兰群岛: 'Aland Islands',
  纽埃岛: 'Niue',
  阿尔巴尼亚: 'Albania',
  阿尔及利亚: 'Algeria',
  美属萨摩亚: 'American Samoa',
  安道尔: 'Andorra',
  安哥拉: 'Angola',
  安圭拉: 'Anguilla',
  安提瓜和巴布达: 'Antigua and Barbuda',
  阿根廷: 'Argentina',
  亚美尼亚: 'Armenia',
  阿鲁巴: 'Aruba',
  澳大利亚: 'Australia',
  奥地利: 'Austria',
  阿塞拜疆: 'Azerbaijan',
  孟加拉: 'Bangladesh',
  巴林: 'Bahrain',
  巴哈马: 'Bahamas',
  巴巴多斯: 'Barbados',
  白俄罗斯: 'Belarus',
  比利时: 'Belgium',
  伯利兹: 'Belize',
  贝宁: 'Benin',
  百慕大: 'Bermuda',
  不丹: 'Bhutan',
  玻利维亚: 'Bolivia',
  波斯尼亚和黑塞哥维那: 'Bosnia and Herzegovina',
  博茨瓦纳: 'Botswana',
  布维岛: 'Bouvet Island',
  巴西: 'Brazil',
  文莱: 'Brunei',
  保加利亚: 'Bulgaria',
  布基纳法索: 'Burkina Faso',
  布隆迪: 'Burundi',
  柬埔寨: 'Cambodia',
  喀麦隆: 'Cameroon',
  加拿大: 'Canada',
  佛得角: 'Cape Verde',
  中非: 'Central African Republic',
  乍得: 'Chad',
  智利: 'Chile',
  圣诞岛: 'Christmas Islands',
  '科科斯（基林）群岛': 'Cocos (keeling) Islands',
  哥伦比亚: 'Colombia',
  科摩罗: 'Comoros',
  '刚果（金）': 'Congo (Congo-Kinshasa)',
  刚果: 'Congo',
  库克群岛: 'Cook Islands',
  哥斯达黎加: 'Costa Rica',
  科特迪瓦: "Cote D'Ivoire",
  中国: 'China',
  克罗地亚: 'Croatia',
  古巴: 'Cuba',
  捷克: 'Czech',
  塞浦路斯: 'Cyprus',
  丹麦: 'Denmark',
  吉布提: 'Djibouti',
  多米尼加: 'Dominica',
  厄瓜多尔: 'Ecuador',
  埃及: 'Egypt',
  赤道几内亚: 'Equatorial Guinea',
  厄立特里亚: 'Eritrea',
  爱沙尼亚: 'Estonia',
  埃塞俄比亚: 'Ethiopia',
  法罗群岛: 'Faroe Islands',
  斐济: 'Fiji',
  芬兰: 'Finland',
  法国: 'France',
  法国大都会: 'MetropolitanFrance',
  法属圭亚那: 'French Guiana',
  法属波利尼西亚: 'French Polynesia',
  加蓬: 'Gabon',
  冈比亚: 'Gambia',
  格鲁吉亚: 'Georgia',
  德国: 'Germany',
  加纳: 'Ghana',
  直布罗陀: 'Gibraltar',
  希腊: 'Greece',
  格林纳达: 'Grenada',
  瓜德罗普岛: 'Guadeloupe',
  关岛: 'Guam',
  危地马拉: 'Guatemala',
  根西岛: 'Guernsey',
  几内亚比绍: 'Guinea-Bissau',
  几内亚: 'Guinea',
  圭亚那: 'Guyana',
  海地: 'Haiti',
  洪都拉斯: 'Honduras',
  匈牙利: 'Hungary',
  冰岛: 'Iceland',
  印度: 'India',
  印度尼西亚: 'Indonesia',
  伊朗: 'Iran',
  伊拉克: 'Iraq',
  爱尔兰: 'Ireland',
  马恩岛: 'Isle of Man',
  以色列: 'Israel',
  意大利: 'Italy',
  牙买加: 'Jamaica',
  日本: 'Japan',
  泽西岛: 'Jersey',
  约旦: 'Jordan',
  哈萨克斯坦: 'Kazakhstan',
  肯尼亚: 'Kenya',
  基里巴斯: 'Kiribati',
  韩国: 'Korea (South)',
  朝鲜: 'Korea (North)',
  科威特: 'Kuwait',
  吉尔吉斯斯坦: 'Kyrgyzstan',
  老挝: 'Laos',
  拉脱维亚: 'Latvia',
  黎巴嫩: 'Lebanon',
  莱索托: 'Lesotho',
  利比里亚: 'Liberia',
  利比亚: 'Libya',
  列支敦士登: 'Liechtenstein',
  立陶宛: 'Lithuania',
  卢森堡: 'Luxembourg',
  马其顿: 'Macedonia',
  马拉维: 'Malawi',
  马来西亚: 'Malaysia',
  马达加斯加: 'Madagascar',
  马尔代夫: 'Maldives',
  马里: 'Mali',
  马耳他: 'Malta',
  马绍尔群岛: 'Marshall Islands',
  马提尼克岛: 'Martinique',
  毛里塔尼亚: 'Mauritania',
  毛里求斯: 'Mauritius',
  马约特: 'Mayotte',
  墨西哥: 'Mexico',
  密克罗尼西亚: 'Micronesia',
  摩尔多瓦: 'Moldova',
  摩纳哥: 'Monaco',
  蒙古: 'Mongolia',
  黑山: 'Montenegro',
  蒙特塞拉特: 'Montserrat',
  摩洛哥: 'Morocco',
  莫桑比克: 'Mozambique',
  缅甸: 'Myanmar',
  纳米比亚: 'Namibia',
  瑙鲁: 'Nauru',
  尼泊尔: 'Nepal',
  荷兰: 'Netherlands',
  新喀里多尼亚: 'New Caledonia',
  新西兰: 'New Zealand',
  尼加拉瓜: 'Nicaragua',
  尼日尔: 'Niger',
  尼日利亚: 'Nigeria',
  纽埃: 'Niue',
  诺福克岛: 'Norfolk Island',
  挪威: 'Norway',
  阿曼: 'Oman',
  巴基斯坦: 'Pakistan',
  帕劳: 'Palau',
  巴勒斯坦: 'Palestine',
  巴拿马: 'Panama',
  巴布亚新几内亚: 'Papua New Guinea',
  秘鲁: 'Peru',
  菲律宾: 'Philippines',
  皮特凯恩群岛: 'Pitcairn Islands',
  波兰: 'Poland',
  葡萄牙: 'Portugal',
  波多黎各: 'Puerto Rico',
  卡塔尔: 'Qatar',
  留尼汪岛: 'Reunion',
  罗马尼亚: 'Romania',
  卢旺达: 'Rwanda',
  俄罗斯联邦: 'Russian Federation',
  圣赫勒拿: 'Saint Helena',
  圣基茨和尼维斯: 'Saint Kitts-Nevis',
  圣卢西亚: 'Saint Lucia',
  圣文森特和格林纳丁斯: 'Saint Vincent and the Grenadines',
  萨尔瓦多: 'El Salvador',
  萨摩亚: 'Samoa',
  圣马力诺: 'San Marino',
  圣多美和普林西比: 'Sao Tome and Principe',
  沙特阿拉伯: 'Saudi Arabia',
  塞内加尔: 'Senegal',
  塞舌尔: 'Seychelles',
  塞拉利昂: 'Sierra Leone',
  新加坡: 'Singapore',
  塞尔维亚: 'Serbia',
  斯洛伐克: 'Slovakia',
  斯洛文尼亚: 'Slovenia',
  所罗门群岛: 'Solomon Islands',
  索马里: 'Somalia',
  南非: 'South Africa',
  西班牙: 'Spain',
  斯里兰卡: 'Sri Lanka',
  苏丹: 'Sudan',
  苏里南: 'Suriname',
  斯威士兰: 'Swaziland',
  瑞典: 'Sweden',
  瑞士: 'Switzerland',
  叙利亚: 'Syria',
  塔吉克斯坦: 'Tajikistan',
  坦桑尼亚: 'Tanzania',
  泰国: 'Thailand',
  特立尼达和多巴哥: 'Trinidad and Tobago',
  东帝汶: 'Timor-Leste',
  多哥: 'Togo',
  托克劳: 'Tokelau',
  汤加: 'Tonga',
  突尼斯: 'Tunisia',
  土耳其: 'Turkey',
  土库曼斯坦: 'Turkmenistan',
  图瓦卢: 'Tuvalu',
  乌干达: 'Uganda',
  乌克兰: 'Ukraine',
  阿拉伯联合酋长国: 'United Arab Emirates',
  英国: 'United Kingdom',
  美国: 'United States',
  乌拉圭: 'Uruguay',
  乌兹别克斯坦: 'Uzbekistan',
  瓦努阿图: 'Vanuatu',
  梵蒂冈: 'Vatican City',
  委内瑞拉: 'Venezuela',
  越南: 'Vietnam',
  瓦利斯群岛和富图纳群岛: 'Wallis and Futuna',
  西撒哈拉: 'Western Sahara',
  也门: 'Yemen',
  南斯拉夫: 'Yugoslavia',
  赞比亚: 'Zambia',
  津巴布韦: 'Zimbabwe',
  '2021年中国国际服务贸易交易会参展商直播协议':
    '2021 China International Fair for Trade in Services Live Exhibitor Agreement',
  立即洽谈: 'Chat Now',
  企业联系人列表: 'Enterprise Contact List',
  咨询顾问: 'Consultant',
  请输入条件搜索: 'Please enter criteria to search',
  '洽谈仅对认证展、客商的咨询顾问和商务代表开放，您无访问权限。':
    'Negotiation rooms are only open to consultants and business representatives of certified exhibitions, merchants, and you do not have permission to access.',
  暂无联系人: 'No contact',
  '2023年企业': 'Enterprises in 2023',
  '2022年企业': 'Enterprises in 2022',
  '2021年企业': 'Enterprises in 2021',
  '2020年企业': 'Enterprises in 2020',
  全部企业: 'All Enterprises',
  请输入搜索内容: 'Please enter the search content',
  全部: 'All',
  国会一期: 'Center Phase I',
  国会二期: 'Center Phase II',
  首钢园区: 'Shougang Park',
  展区导览: 'Exhibition Area Guide',
  系统维护中: 'System Maintenance',
  展商名录搜索: 'Exhibitor List Search'
}
